import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { store } from '../Store';
import './Menu.css';

import facebook from '../assets/images/facebook.png';
import facebookLarge from '../assets/images/facebook@2x.png';
import twitter from '../assets/images/twitter.png';
import twitterLarge from '../assets/images/twitter@2x.png';
import youtube from '../assets/images/youtube.png';
import youtubeLarge from '../assets/images/youtube@2x.png';
import linkedin from '../assets/images/linkedin.png';
import linkedinLarge from '../assets/images/linkedin@2x.png';

const Menu = observer((props) => {
  return (
    <div className={ classNames('menu', { 'visible' : store.menuOpen }) }>
      <div className="overlay" onClick={() => { store.setMenuOpen(false); }}></div>
      <div className="panel">
        <div className="main">
          <div dangerouslySetInnerHTML={{ __html: props.content.menu.intro }} />

          <ul className="links">
          {props.content.menu.sections.map((section, i) => {
            return (
              <li key={i}>
                <a href={ section.url } target="_blank" dangerouslySetInnerHTML={{ __html: section.text }} />
              </li>
            )
          })}
          </ul>
        </div>

        <footer>
          <ul className="social">  
            <li>
              <a href={props.content.menu.social.facebook} target="_blank">
                <img src={facebook} srcSet={`${facebook}, ${facebookLarge} 2x`} alt="Facebook" />
              </a>
            </li>
            <li>
              <a href={props.content.menu.social.twitter} target="_blank">
                <img src={twitter} srcSet={`${twitter}, ${twitterLarge} 2x`} alt="Twitter" />
              </a>
            </li>
            <li>
              <a href={props.content.menu.social.youtube} target="_blank">
                <img src={youtube} srcSet={`${youtube}, ${youtubeLarge} 2x`} alt="Instagram" />
              </a>
            </li>
            <li>
              <a href={props.content.menu.social.linkedin} target="_blank">
                <img src={linkedin} srcSet={`${linkedin}, ${linkedinLarge} 2x`} alt="Share" />
              </a>
            </li>
          </ul>

          <div dangerouslySetInnerHTML={{ __html: props.content.menu.footer }} />
        </footer>
      </div>
    </div>   
  )
});

export { Menu };